import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useWorkshops } from '@/api/hooks/useWorkshops'
import PageLayout from '@/components/layout/page-layout'
import WorkshopsTable from '@/components/organisms/workshops-table'

export const Route = createFileRoute('/_authenticated/manage-workshops/')({
  component: ManageWorkshopsPage,
})

function ManageWorkshopsPage() {
  const { t } = useTranslation()
  const { data: workshops } = useWorkshops()
  const organization = workshops[0]?.organization

  return (
    <PageLayout title={t('workshopSettingsPage.title')}>
      <WorkshopsTable workshops={workshops} organization={organization} />
    </PageLayout>
  )
}
